module.exports = __webpack_public_path__ + "img/cvalenzuela.7aed50ac.jpg";